import { ACCOUNT_ID, DIMENSION } from 'hooks';
import { CAMPAIGNS_ROUTE } from '../../../../../config';
import {
    ActionableTextWithInternalLinkCellRenderer,
    FormattedMessageWithTooltipHeaderRenderer,
    gridNumberFormatter,
    formattedNumberValueGetter,
} from '../../../components';
import { DATE_PRESET, END_DATE, START_DATE } from '../../../hooks';
import { normalizeColumnDefs } from '../../../utils';
import { leftPinnedColumn, numericColumn } from '../../columns';
import * as FIELDS from '../../fields';
import { ACCOUNT_VIDEO_REPORT_ID } from './accountVideoReportId';

const accountReportColumnDefinition = [
    ...[
        {
            headerName: FIELDS.ACCOUNT_ID.label,
            field: FIELDS.ACCOUNT_ID.field,
        },
        {
            headerName: FIELDS.ACCOUNT_DESCRIPTION.label,
            field: FIELDS.ACCOUNT_DESCRIPTION.field,
            type: [leftPinnedColumn],
            cellRenderer: ActionableTextWithInternalLinkCellRenderer,
            cellRendererParams: {
                lines: 2,
                to: CAMPAIGNS_ROUTE,
                paramsToKeep: [DIMENSION, START_DATE, END_DATE, DATE_PRESET],
                paramsFactory: ({ accountId }) => ({
                    [ACCOUNT_ID]: accountId,
                }),
            },
        },
    ],
    ...[
        FIELDS.SPENT,
        FIELDS.COMPLETED_VIEWS,
        FIELDS.UNIQUE_IMPRESSIONS,
        FIELDS.UNIQUE_VIEWABLE_IMPRESSIONS,
        FIELDS.UNIQUE_COMPLETED_VIEWS,
        FIELDS.VIDEO_IMPRESSIONS,
        FIELDS.VIDEO_VISIBLE_IMPRESSIONS,
        FIELDS.VIDEO_CPM,
        FIELDS.VIDEO_VCPM,
        FIELDS.CPCV,
        FIELDS.VIEWABILITY_RATE,
        FIELDS.HUNDRED_PCT_VIEWABILITY_RATE,
        FIELDS.COMPLETION_RATE,
        FIELDS.CLICKS,
        FIELDS.VIDEO_CTR,
        FIELDS.VIDEO_VCTR,
        FIELDS.CPA,
        FIELDS.VIDEO_CVR,
        FIELDS.CONVERSIONS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        cellRenderer: fieldConfig.cellRenderer,
        valueFormatter: !fieldConfig.cellRenderer && gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(accountReportColumnDefinition, ACCOUNT_VIDEO_REPORT_ID);
